import {
  FaCalendarAlt,
  FaRandom,
  FaUndoAlt,
  FaDice,
  FaTrash,
  FaSearch,
} from 'react-icons/fa';
import { BsGraphDown, BsGraphUp } from 'react-icons/bs';
import { TbGpsFilled } from 'react-icons/tb';
import {
  MdAlignHorizontalLeft,
  MdAlignHorizontalRight,
  MdAlignVerticalBottom,
  MdBarChart,
  MdSportsSoccer,
} from 'react-icons/md';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MatchListBetGeneration } from './MatchListBetGenaration';
import {
  getDrawSingleRandomPrediction,
  getExactResultSingleRandomPrediction,
  getGoalGoalSingleRandomPrediction,
  getNoGoalSingleRandomPrediction,
  getOver2Point5SingleRandomPrediction,
  getUnder3Point5SingleRandomPrediction,
  MainMatchesPrevisionData,
  getOver1Point5SingleRandomPrediction,
  getMultigol2_5SingleRandomPrediction,
  getMultigol1_3SingleRandomPrediction,
  getMultigol1_3HomeSingleRandomPrediction,
  getMultigol1_3AwaySingleRandomPrediction,
  getUnder1Point5HomeSingleRandomPrediction,
  getUnder1Point5AwaySingleRandomPrediction,
} from './MainMatchesData';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TailSpin } from 'react-loader-spinner';

const BetGenerationPage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    localStorage.getItem('selectedDateBetGen') ||
      new Date().toISOString().split('T')[0],
  );
  const [selectedBet, setSelectedBet] = useState(
    localStorage.getItem('selectedBetBetGen') || 'GoalGoal',
  );
  const [selectedLeague, setSelectedLeague] = useState(
    localStorage.getItem('selectedLeagueBetGen') || '',
  );
  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState<any[]>([]);
  const dateInputRef = useRef<HTMLInputElement>(null);
  const leagueInputRef = useRef<HTMLSelectElement>(null);
  const [loadingTime, setLoadingTime] = useState(0);

  const leagues = [
    { id: 'Bundesliga 1', name: 'Bundesliga 1' },
    { id: 'Bundesliga 2', name: 'Bundesliga 2' },
    { id: 'Eredivisie', name: 'Eredivisie' },
    { id: 'La Liga', name: 'La Liga' },
    { id: 'League 2', name: 'League 2' },
    { id: 'Liga Portugal', name: 'Liga Portugal' },
    { id: 'Ligue 1', name: 'Ligue 1' },
    { id: 'Premier League', name: 'Premier League' },
    { id: 'Serie A', name: 'Serie A' },
    { id: 'Serie B', name: 'Serie B' },
    { id: 'Super League', name: 'Super League' },
    { id: 'Super Lig', name: 'Super Lig' },
    { id: 'MLS', name: 'MLS' },
    { id: 'Allsvenskan', name: 'Allsvenskan' },
    { id: 'Eliteserien', name: 'Eliteserien' },
    { id: 'Veikkausliiga', name: 'Veikkausliiga' },
    { id: 'Premier Division', name: 'Premier Division' },
    { id: 'Superliga', name: 'Superliga' },
    { id: 'Ekstraklasa', name: 'Ekstraklasa' },
  ];

  // Save filters when user selects a new filter
  useEffect(() => {
    localStorage.setItem('selectedDateBetGen', selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    localStorage.setItem('selectedBetBetGen', selectedBet);
  }, [selectedBet]);

  useEffect(() => {
    localStorage.setItem('selectedLeagueBetGen', selectedLeague);
  }, [selectedLeague]);

  // Save tableData to LocalStorage when it changes
  useEffect(() => {
    if (tableData.length > 0) {
      localStorage.setItem('tableDataBetGen', JSON.stringify(tableData));
    }
  }, [tableData]);

  // Load tableData from LocalStorage when the page loads
  useEffect(() => {
    const savedData = localStorage.getItem('tableDataBetGen');
    if (savedData) {
      setTableData(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    if (!localStorage.getItem('selectedDateBetGen')) {
      setSelectedDate(today);
    }
    if (dateInputRef.current) {
      if (selectedDate === today) {
        dateInputRef.current.classList.remove(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      } else {
        dateInputRef.current.classList.add(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      }
    }
    const leagueVal = '';
    if (!localStorage.getItem('selectedLeagueBetGen')) {
      setSelectedLeague(leagueVal);
    }
    if (leagueInputRef.current) {
      if (selectedLeague === 'All') {
        leagueInputRef.current.classList.remove(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      } else {
        leagueInputRef.current.classList.add(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      }
    }
  }, []);

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);

    // Get current date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    // Modify input class based on selected date
    if (dateInputRef.current) {
      if (newDate === today) {
        dateInputRef.current.classList.remove(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      } else {
        dateInputRef.current.classList.add(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      }
    }
  };

  const handleLeagueChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newVal = event.target.value;
    setSelectedLeague(newVal);
    if (leagueInputRef.current) {
      if (newVal === 'All') {
        leagueInputRef.current.classList.remove(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      } else {
        leagueInputRef.current.classList.add(
          'bg-gradient-to-r',
          'from-indigo-600',
          'to-purple-600',
          'text-white',
          'border',
          'border-white/10',
          'scale-105',
        );
      }
    }
  };
  // All prediction functions remain the same
  const doGetGoalGoalSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getGoalGoalSingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetNoGoalSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getNoGoalSingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetOver2Point5SingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getOver2Point5SingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetUnder3Point5SingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getUnder3Point5SingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetDrawSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getDrawSingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetOver1Point5ResultSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getOver1Point5SingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetMultigol2_5SingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getMultigol2_5SingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetMultigol1_3SingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getMultigol1_3SingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetMultigol1_3HomeSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getMultigol1_3HomeSingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetMultigol1_3AwaySingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getMultigol1_3AwaySingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetUnder1Point5HomeSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getUnder1Point5HomeSingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetUnder1Point5AwaySingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getUnder1Point5AwaySingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const doGetExactResultSingleRandomPrediction = async (
    date: string,
    league: string,
    excludedPredictionIds: string,
  ) => {
    const retMatches = await getExactResultSingleRandomPrediction(
      date,
      league,
      excludedPredictionIds,
    );
    return retMatches;
  };

  const handleButtonClick = async (
    type: string,
    date?: string,
    league?: string,
  ) => {
    setIsLoading(true); // Start loading
    setLoadingTime(Date.now()); // Save loading start time

    const searchDate = date || selectedDate;
    let searchLeague = league || selectedLeague;
    const excludedPredictionIds = tableData
      .map((m) => m.PredictionId)
      .join(',');

    if (searchLeague === 'All') searchLeague = '';

    let result: MainMatchesPrevisionData | null = null;

    // Handle async calls based on type
    switch (type) {
      case 'GoalGoal':
        result = await doGetGoalGoalSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'NoGoal':
        result = await doGetNoGoalSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Over2.5':
        result = await doGetOver2Point5SingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Under3.5':
        result = await doGetUnder3Point5SingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Draw':
        result = await doGetDrawSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'ExactResult':
        result = await doGetExactResultSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Over1.5':
        result = await doGetOver1Point5ResultSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Multigol2_5':
        result = await doGetMultigol2_5SingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Multigol1_3':
        result = await doGetMultigol1_3SingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Multigol1_3H':
        result = await doGetMultigol1_3HomeSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Multigol1_3A':
        result = await doGetMultigol1_3AwaySingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Under1.5H':
        result = await doGetUnder1Point5HomeSingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      case 'Under1.5A':
        result = await doGetUnder1Point5AwaySingleRandomPrediction(
          searchDate,
          searchLeague,
          excludedPredictionIds,
        );
        break;
      default:
        break;
    }

    // Minimum loading time
    const minLoadingTime = 400;
    const loadingStartTime = Date.now();
    const timeout = setTimeout(() => {
      if (Date.now() - loadingStartTime >= minLoadingTime) {
        setIsLoading(false);
      }
    }, minLoadingTime);

    await new Promise<void>((resolve) =>
      setTimeout(
        resolve,
        Math.max(0, minLoadingTime - (Date.now() - loadingStartTime)),
      ),
    );

    // Handle result
    if (result) {
      setTableData((prevData) => {
        const exists = prevData.some(
          (item) =>
            item.MatchId === result!.MatchId &&
            result!.PredictionType === item.PredictionType,
        );
        if (!exists) {
          return [...prevData, result!];
        }
        return prevData;
      });
    } else {
      toast.warning(t('betGeneration.noResults'), {
        position: 'bottom-center',
        autoClose: 2000,
        style: {
          backgroundColor: 'rgba(15, 23, 42, 0.9)',
          color: '#6ee7b7',
          borderLeft: '4px solid #6ee7b7',
        },
      });
    }

    setIsLoading(false);
  };

  // Filter matches by search query
  const filteredTableData = searchQuery
    ? tableData.filter((match) => {
        const query = searchQuery.toLowerCase();
        return (
          match.Home.toLowerCase().includes(query) ||
          match.Away.toLowerCase().includes(query) ||
          match.League.toLowerCase().includes(query) ||
          match.Country?.toLowerCase().includes(query)
        );
      })
    : tableData;

  const betTypes = [
    { id: 'GoalGoal', label: t('betTypes.goalGoal'), icon: <FaRandom /> },
    { id: 'Over1.5', label: t('betTypes.over1_5'), icon: <BsGraphUp /> },
    { id: 'Under3.5', label: t('betTypes.under3_5'), icon: <BsGraphDown /> },
    {
      id: 'Multigol2_5',
      label: t('betTypes.multigol2_5'),
      icon: <MdBarChart />,
    },
    {
      id: 'Multigol1_3',
      label: t('betTypes.multigol1_3'),
      icon: <MdAlignVerticalBottom />,
    },
    {
      id: 'Multigol1_3H',
      label: t('betTypes.multigol1_3H'),
      icon: <MdAlignHorizontalLeft />,
    },
    {
      id: 'Multigol1_3A',
      label: t('betTypes.multigol1_3A'),
      icon: <MdAlignHorizontalRight />,
    },
    { id: 'Under1.5H', label: t('betTypes.under1_5H'), icon: <BsGraphDown /> },
    { id: 'Under1.5A', label: t('betTypes.under1_5A'), icon: <BsGraphDown /> },
    {
      id: 'ExactResult',
      label: t('betTypes.exactResult'),
      icon: <MdSportsSoccer />,
    },
  ];

  return (
    <div className="py-14 pt-20 px-4 sm:px-6 lg:px-8 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <div className="text-center mb-10">
          <h1 className="text-2xl sm:text-4xl font-extrabold mb-3 text-white tracking-tight flex items-center justify-center gap-3 sm:gap-4">
            <span className="inline-flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-indigo-600/30 to-purple-600/30 backdrop-blur-sm border border-white/10 shadow-lg flex-shrink-0">
              <FaDice className="text-lg sm:text-xl text-teal-400" />
            </span>
            {t('betGeneration.title')}
          </h1>
          <p className="text-gray-400 max-w-xl mx-auto text-sm sm:text-base">
            {t('betGeneration.subtitle')}
          </p>
        </div>

        {/* Loading Overlay */}
        {isLoading && (
          <div className="fixed inset-0 bg-gray-900/80 backdrop-blur-sm z-50 flex justify-center items-center">
            <div className="glass-card p-8 rounded-2xl flex flex-col items-center">
              <TailSpin color="#5eead4" height={50} width={50} />
              <p className="mt-4 text-teal-300 font-medium">
                {t('betGeneration.generatingPrediction')}
              </p>
            </div>
          </div>
        )}

        {/* Filters Row */}
        <div className="mb-6 flex flex-wrap items-center justify-center gap-4">
          <div className="relative">
            <input
              type="date"
              id="matchDate"
              name="matchDate"
              value={selectedDate}
              onChange={handleDateChange}
              ref={dateInputRef}
              className="appearance-none pl-10 pr-4 py-2 rounded-xl text-xs sm:text-sm bg-white/[0.04] backdrop-blur-sm border border-white/[0.08] text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-transparent shadow-lg transition-all"
            />
            <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-teal-400 pointer-events-none" />
          </div>

          <div className="relative">
            <select
              value={selectedLeague}
              onChange={handleLeagueChange}
              ref={leagueInputRef}
              className="appearance-none pl-10 pr-4 py-2 rounded-xl text-xs sm:text-sm bg-white/[0.04] backdrop-blur-sm border border-white/[0.08] text-white focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-transparent shadow-lg transition-all cursor-pointer"
            >
              <option value="All">
                {t('betGeneration.allLeagues') as string}
              </option>
              {leagues.map((league) => (
                <option key={league.id} value={league.id}>
                  {league.name}
                </option>
              ))}
            </select>
            <TbGpsFilled className="absolute left-3 top-1/2 -translate-y-1/2 text-teal-400 pointer-events-none" />
          </div>
        </div>

        {/* Bet Type Buttons */}
        <div className="mb-6 flex flex-wrap items-center justify-center gap-4">
          {betTypes.map((betType) => (
            <button
              key={betType.id}
              onClick={() => {
                setSelectedBet(betType.id);
                handleButtonClick(betType.id);
              }}
              className={`flex items-center px-4 py-2 rounded-xl text-xs sm:text-sm font-medium transition-all duration-300 ${
                selectedBet === betType.id
                  ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-600/20 scale-105 border border-white/10'
                  : 'bg-white/[0.04] backdrop-blur-sm text-gray-400 hover:text-white hover:bg-white/[0.08] border border-white/[0.06]'
              }`}
            >
              <span className="mr-2">{betType.icon}</span>
              {betType.label}
            </button>
          ))}

          {/* Table control buttons */}
          {tableData.length > 0 && (
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setTableData([]);
                  localStorage.setItem('tableDataBetGen', '');
                }}
                className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/[0.04] backdrop-blur-sm border border-red-500/30 text-red-400 hover:bg-red-500/10 hover:border-red-500/50 transition-all shadow-lg"
                title={t('betGeneration.clearAll') as string}
              >
                <FaTrash />
              </button>

              <button
                onClick={() => {
                  setTableData((prevData) => prevData.slice(0, -1));
                  if (tableData.length === 1) {
                    localStorage.setItem('tableDataBetGen', '');
                  }
                }}
                className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/[0.04] backdrop-blur-sm border border-teal-500/30 text-teal-400 hover:bg-teal-500/10 hover:border-teal-500/50 transition-all shadow-lg"
                title={t('betGeneration.removeLast') as string}
              >
                <FaUndoAlt />
              </button>
            </div>
          )}
        </div>

        {/* Results Table */}
        <div className="glass-card overflow-hidden">
          <div className="bg-gradient-to-r from-indigo-900/60 to-purple-900/60 py-3.5 px-5 border-b border-white/[0.06]">
            <h2 className="text-base font-bold text-white flex items-center">
              <span className="mr-2 text-teal-400">
                <FaDice />
              </span>
              {t('betGeneration.generatedSelections')}
              <span className="ml-auto text-sm font-normal text-gray-400 bg-white/[0.06] px-3 py-1 rounded-full">
                {filteredTableData.length} {t('betGeneration.matches')}
              </span>
            </h2>
          </div>

          <div className="overflow-x-auto">
            <ToastContainer />
            {filteredTableData && filteredTableData.length > 0 ? (
              <MatchListBetGeneration data={filteredTableData} />
            ) : (
              <div className="text-center py-16">
                <div className="inline-block p-4 rounded-full bg-slate-700 bg-opacity-50 mb-4">
                  <FaDice className="h-10 w-10 text-gray-400" />
                </div>
                <p className="text-gray-300 text-lg font-medium">
                  {t('betGeneration.noSelectionsYet')}
                </p>
                <p className="text-gray-400 mt-2">
                  {t('betGeneration.clickBetType')}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetGenerationPage;
